/**
 *
 * DocumentLanguageUpdater.react.js
 *
 * An additional decorator class which sets the lang attribute to the html tag
 *
 * NOTE: Needed for cookie banner language switch
 */

import { Component } from 'react';
import type { ReactNode } from 'react';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

export interface DocumentLanguageUpdaterProps {
  children?: ReactNode;
  intl: IntlShape;
}

export class DocumentLanguageUpdater extends Component<DocumentLanguageUpdaterProps> {
  componentDidMount() {
    this.updateDocumentLanguage(this.getDocumentLanguage(this.props.intl.locale));
  }

  componentDidUpdate(prevProps: DocumentLanguageUpdaterProps) {
    if (prevProps.intl.locale !== this.props.intl.locale) this.updateDocumentLanguage(this.getDocumentLanguage(this.props.intl.locale));
  }

  getDocumentLanguage(lang: string): string | undefined {
    return {
      en: 'en-GB',
      de: 'de-DE',
    }[lang];
  }

  updateDocumentLanguage(lang: string | undefined) {
    window.document.documentElement.lang = lang as string;
  }

  render() {
    return this.props.children;
  }
}

export default injectIntl(DocumentLanguageUpdater);
